export const VIEW_PERMISSIONS = 'VIEW_PERMISSIONS';
